import { SET_APP_INITIALISED, SET_APP_LOADING, SET_APP_LOADED } from "../actions/loading";


const initialLoadedState = {
    appInitialising: true,  // when app starts up
    appLoading: false,  // when app goes into loading state after initial start up, e.g. ajax requests
};

export function loading(state = initialLoadedState, action) {
    switch (action.type) {

        case SET_APP_INITIALISED:
            return {
                ...state,
                appInitialising: false,
            };

        case SET_APP_LOADING:
            return {
                ...state,
                appLoading: true,
            };

        case SET_APP_LOADED:
            return {
                ...state,
                appLoading: false,
            };

        default:
            return state
    }
}
